import React from 'react';
import styled, {keyframes} from 'styled-components';
import { useSelector } from 'react-redux';


const subirAgua = keyframes`
0% { background-position-y: 0%; }
100% { background-position-y: ${props => props.porcentaje}%; }
`;

const moverAgua = keyframes`
0% { background-position-x: 0px; }
100% { background-position-x: 140px; }
`;

const Dibujo = styled.div`
        display: flex;
        background-repeat: repeat-x;;
        background: url('/assets/images/water.png');
        animation: ${moverAgua} 1.1s linear infinite, ${subirAgua} ${props => props.porcentaje*.05}s linear 1;
        background-position-y: ${props => props.porcentaje}%;

        &::after {
            content: '';
            width: 200px;
            height: 200px;
        }

        ::after {
            transition: filter .5s ease;
            background: url('/assets/images/logoBackground.svg');
        }
    `;

export const Progreso = () => {

    const {costoPaquete} = useSelector(state => state.client);
    const {total} = useSelector(state => state.payments);

    const porcentaje = total * 100 / costoPaquete;
    
    return (
        <div className="card pt-3">
            <div className="text-center">
                <div className="row mb-0">
                    <div className="col">
                        <p className="text-muted mb-1">Costo de paquete</p>
                        <h6 className="mt-0 text-truncate">{ new Intl.NumberFormat("en-US", {style: "currency", currency: "MXN"}).format(costoPaquete) }</h6>
                    </div>
                    <div className="col">
                        <p className="text-muted mb-1">Pagado</p>
                        <h6 className="mt-0 text-truncate d-flex align-items-center justify-content-center">
                            <span className="total_pagos-span">{ new Intl.NumberFormat("en-US", {style: "currency", currency: "MXN"}).format(total) }</span> &nbsp;
                            {/* <small className="badge badge-info font-13">{porcentaje}%</small> */}
                        </h6>
                    </div>
                </div>
                <div className="row">
                    <div className="col-m-4 col-6 offset-3">
                        <p className="text-muted mb-1">Saldo restante</p>
                        <h6 className="mt-0 text-truncate">{ new Intl.NumberFormat("en-US", {style: "currency", currency: "MXN"}).format(costoPaquete - total) }</h6>
                    </div>
                </div>
            </div>
            <div id="logoProgreso" className="d-flex justify-content-center m-4">
                <Dibujo porcentaje={porcentaje} className="progreso"></Dibujo>
            </div>
        </div>
    )
}
